import React from "react";
import classNames from "classnames";
import { Fade } from "react-awesome-reveal";
import { ICurrencyConverter } from "@app/models/storyblok/blocks/currency-converter";
import { DEFAULT_FADE_DURATION } from "@app/constants";
import { Benefits } from "./components/benefits/Benefits";
import { formatBenefits } from "./formatter";
import { Converter } from "./components/converter/Converter";

type Props = {
  content: ICurrencyConverter;
};

export const CurrencyConverter: React.FC<Props> = ({ content }) => {
  return (
    <Fade
      duration={DEFAULT_FADE_DURATION}
      triggerOnce
      className={classNames(
        "bg-dark text-primary-content mt-20 flex justify-center px-5 py-20",
        "lg:mt-25 lg:px-16",
        "xl:mt-40 xl:px-24 xl:py-30",
      )}
    >
      <div
        className={classNames(
          "flex flex-col gap-15",
          "lg:gap-20",
          "xl:max-w-container xl:gap-25",
        )}
      >
        <h3
          className={classNames(
            "text-large m-auto text-center",
            "xl:text-xx-large xl:max-w-[980px]",
          )}
        >
          {content.title}
        </h3>

        <div
          className={classNames(
            "flex flex-col-reverse gap-11",
            "lg:flex-row lg:justify-between lg:gap-36",
            "xl:items-center",
            "xxl:gap-44",
          )}
        >
          <Benefits benefits={formatBenefits(content.benefits)} />

          <Converter />
        </div>

        <p
          className={classNames(
            "text-tiny text-base-400",
            "lg:text-extra-small",
          )}
        >
          {content.footnote}
        </p>
      </div>
    </Fade>
  );
};
